/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Role_Store_ManagerInputs */

const en_contact_role_store_manager = /** @type {(inputs: Contact_Role_Store_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store manager`)
};

/**
* | output |
* | --- |
* | "Store manager" |
*
* @param {Contact_Role_Store_ManagerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_role_store_manager = /** @type {((inputs?: Contact_Role_Store_ManagerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Role_Store_ManagerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_role_store_manager(inputs)
});